import './HomeComponents.css';

const StatsSection = () => {
  return (
    <section className="stats">
      <div className="stats-container">
        <div className="stat-item">
          <div className="stat-number">10K+</div>
          <div className="stat-label">Downloads</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">5K+</div>
          <div className="stat-label">Tasks Completed</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">500+</div>
          <div className="stat-label">Active Helpers</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">4.9</div>
          <div className="stat-label">Average Rating</div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;